import React, { Component } from 'react';
import { Button, Modal, Popup, Label } from 'semantic-ui-react';
import map from 'lodash/map';
import sortBy from 'lodash/sortBy';
import { getPages } from '../../../fbApi/Page';
import AdLibraryLaunchDestinationFields from './AdLibraryLaunchDestinationFields';

class AdLibraryLaunchDestinationFieldsModal extends Component {
  state = {
    accounts: this.props.accounts,
    data: null,
    showYearSelector: false,
    showMonthSelector: false,
    selectedYear: '',
    selectedMonth: '',
    showMonthLoader: false,
    showYearLoader: false,
    showAdsetLoader: false,
    showAdsetsSelector: false,
    selectedCampaigns: [],
    filteredCampaigns: [],
    years: [],
    pages: [],
    campaigns: [],
    campaign_ids: [],
    productSets: [],
    processing: false,
    selectedPage: '',
    form: {
      accountId: '',
      accountName: '',
      adsets: [],
      pixel: '',
      pageId: '',
      pageAccessToken: '',
      instagramAccount: '',
      displayUrl: '',
      productCatalog: '',
      productSet: ''
    },
    loadingPages: false
  };

  async componentDidMount() {
    await this.fetchPages();
  }

  fetchPages = async () => {
    const { pages: pagesFromState } = this.state;
    if (!pagesFromState || pagesFromState.length > 0) {
      return;
    }

    const { getFbToken, user } = this.props;
    const token = getFbToken();
    this.setState({ ...this.state, loadingPages: true }, async () => {
      const pages = await getPages(token, user.groups[0]);
      if (!pages || pages.length < 1) {
        this.setState((prevState) => ({
          ...prevState,
          loadingPages: false
        }));
        return;
      }

      const filteredPages = pages[0].data
        .concat(pages[1].data)
        .filter((page) => page.access_token);
      const pagesOptions = sortBy(
        map(filteredPages, (page, index) => ({
          key: index,
          value: { pageId: page.id, access_token: page.access_token },
          text: page.name
        })),
        'text'
      );

      this.setState((prevState) => ({
        ...prevState,
        pages: pagesOptions,
        loadingPages: false
      }));
    });
  };

  renderModalHeader = () => {
    return (
      <div>
        Fill Launch Destination Fields{' '}
        <Popup
          trigger={<Label floating circular content="?" />}
          content="By filling and clicking Apply, the field values will be applied to all ad prototypes to be launched"
          position="right center"
        />
      </div>
    );
  };

  setLocalState = (parametersObject, callback = null) => {
    this.setState({ ...parametersObject }, () => {
      if (callback) {
        callback();
      }
    });
  };

  applyDestinationValues = () => {
    const {
      fillDestininationFieldsForEachAd,
      toggleDestinationFieldsModal
    } = this.props;
    const fillParams = { ...this.state };
    delete fillParams.accounts;
    if (fillDestininationFieldsForEachAd) {
      fillDestininationFieldsForEachAd(fillParams);
      if (toggleDestinationFieldsModal) toggleDestinationFieldsModal(false);
    }
  };

  render() {
    const {
      showMonthLoader,
      showYearLoader,
      showAdsetLoader,
      campaign_ids: campaignIds
    } = this.state;
    const {
      openModal,
      toggleDestinationFieldsModal,
      getFbToken,
      launchIncludesCollectionAds,
      productCatalogs
    } = this.props;
    return (
      <div>
        <Modal
          size="tiny"
          open={openModal}
          onClose={() => toggleDestinationFieldsModal(false)}
          closeOnEscape
          closeOnDimmerClick
        >
          <Modal.Header>{this.renderModalHeader()}</Modal.Header>
          <Modal.Content scrolling>
            <AdLibraryLaunchDestinationFields
              getFbToken={getFbToken}
              stateFromParent={this.state}
              setStateInParent={this.setLocalState}
              productCatalogs={productCatalogs}
              launchIncludesCollectionAds={launchIncludesCollectionAds}
            />
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={() => toggleDestinationFieldsModal(false)}>
              Close
            </Button>
            <Button
              primary
              icon="checkmark"
              labelPosition="right"
              content="Apply"
              disabled={
                showMonthLoader ||
                showYearLoader ||
                showAdsetLoader ||
                !campaignIds ||
                (campaignIds && campaignIds.length <= 0)
              }
              onClick={this.applyDestinationValues}
            />
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

export default AdLibraryLaunchDestinationFieldsModal;



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/AdLibrary/AdLibraryLaunchDestinationFieldsModal.jsx